import * as React from "react"
import { ErrorPage, type ErrorPageProps } from "./ErrorPage"
import NotFoundIllustration from "../../../assets/illustrations/not-found.svg"

export interface Error404Props extends Partial<Omit<ErrorPageProps, "code">> {
  /**
   * Custom illustration for the 404 page
   */
  illustration?: React.ReactNode
}

const NotFoundIllustrationComponent = () => (
  <img src={NotFoundIllustration} className="w-full h-full" />
)

function Error404({
  title = "Page Not Found",
  description = "Sorry, we couldn't find the page you're looking for. The page might have been moved, deleted, or never existed.",
  illustration,
  ...props
}: Error404Props) {
  return (
    <ErrorPage
      title={title}
      description={description}
      illustration={illustration || <NotFoundIllustrationComponent />}
      {...props}
    />
  )
}

Error404.displayName = "Error404"

export { Error404 }
